import * as actionType from './ActionType';

export const setStep03 = (data) => ({
  type: actionType.SET_VALUE_STEP03,
  payload: data
});

export const setStep03_01 = (data) => ({
  type: actionType.SET_VALUE_STEP03_01,
  payload: data
});

export const setStep03_02 = (data) => ({
  type: actionType.SET_VALUE_STEP03_02,
  payload: data
});
